/**
 * El deep link del push: `/?share=<id>` (oficina) y `/inspector?share=<id>` (app de campo, spec
 * §4.11). La página lo lee UNA vez al montar y lo borra de la URL para no re-disparar al recargar;
 * la tarjeta se abre solo si la invitación sigue viva en `/state` (la URL nunca es fuente de verdad).
 *
 * Puro: sin `window`, para probarlo en vitest/node.
 */

/** Hasta 18 dígitos: el id es un bigint de Postgres; con 20+ desbordaría y el servidor daría 400. */
const ID_RE = /^\d{1,18}$/;

/** `?share=123` → 123; sin la clave, vacía o con basura → null. Acepta con o sin el `?` inicial. */
export function parseShareDeepLink(search: string | null | undefined): number | null {
  if (!search) return null;
  let params: URLSearchParams;
  try { params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search); } catch { return null; }
  const raw = params.get('share');
  if (raw == null) return null;
  const v = raw.trim();
  if (!ID_RE.test(v)) return null;
  const n = Number(v);
  return Number.isSafeInteger(n) && n > 0 ? n : null;
}

/** La misma URL sin `share=`: lo que se deja en la barra con `history.replaceState`. */
export function stripShareDeepLink(href: string): string {
  try {
    const u = new URL(href, 'http://x');
    if (!u.searchParams.has('share')) return u.pathname + u.search + u.hash;
    u.searchParams.delete('share');
    return u.pathname + u.search + u.hash;
  } catch { return href; }
}
